export default __webpack_public_path__ + "static/media/32.04b74459.png";